import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import {PROTOCOLS} from "../../util/Validations";
import {AUTO_LOADER_ASSET_TYPE} from "../../util/Constants";
import {AutoLoaderDeviceOverviewContext} from "./context/AutoLoaderDeviceOverviewContext";
import CommonDeviceLogstream from "../../commonui/CommonDeviceLogstream";

const AutoLoaderDeviceLogstream = ({intl}) => {

    const {viewModel, dispatch} = useContext(AutoLoaderDeviceOverviewContext);
    const deviceList = Object.values(viewModel.autoLoaderDeviceInformation);

    const props = {
        protocols: PROTOCOLS.AUTO_LOADER,
        dispatch,
        deviceList,
        deviceType: AUTO_LOADER_ASSET_TYPE,
        intl
    }
    return (
        <Column>
            <CommonDeviceLogstream {...props}/>
        </Column>
    );
}

export default injectIntl(AutoLoaderDeviceLogstream)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoloader/AutoLoaderDeviceLogstream.js